import { instance as axios } from "./baseUrl";

export const claimEmail = (data) => axios.post("/email", data);

export const postClaim = (data) => axios.post("/claims", data);

export const getClaims = () => axios.get("/claims");
